import type {NodeCodeToIdsMap} from 'services/thesaurus/functions/types';
import type {ThesaurusValue} from 'services/thesaurus/types';

export const mapThesaurusValueToNodeIds = (
  nodeCodes: ThesaurusValue | undefined,
  codeToIdsMap: NodeCodeToIdsMap,
): string[] =>
  (nodeCodes || []).map(nodeCode => codeToIdsMap.get(nodeCode) ?? []).flat();
